import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { Button } from "./ui/button";
import { Clock, Building2, MapPin, Tag, FileText, Users } from "lucide-react";
import { formatDateFr } from "../lib/dateFormat";

/**
 * Modale "Consulter" — affichage détaillé d'un événement d'agenda département.
 */
export default function EventDetailsDialog({ open, onOpenChange, event, brand, site, beneficiary, category }) {
  if (!event) return null;
  const Row = ({ icon: Icon, label, value, testId }) => (
    <div className="flex items-start gap-3">
      <Icon size={14} className="text-zinc-400 mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="label-uppercase mb-0.5">{label}</p>
        <p className="text-sm text-zinc-900 break-words" data-testid={testId}>
          {value || <span className="text-zinc-400 font-mono text-xs">—</span>}
        </p>
      </div>
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="flex flex-col max-h-[90vh] p-0 sm:max-w-lg" data-testid="event-details-dialog">
        <DialogHeader className="px-6 pt-6 pb-4 border-b border-zinc-100">
          <DialogTitle>{event.title || beneficiary?.denomination || "Intervention"}</DialogTitle>
          <p className="text-xs text-zinc-500 font-mono mt-1">
            {formatDateFr(event.date)} · {event.start_time}–{event.end_time}
          </p>
        </DialogHeader>
        <div className="overflow-y-auto px-6 py-5 flex-1 space-y-4">
          <Row icon={Clock} label="Horaires" value={`${event.start_time} → ${event.end_time}`} testId="ed-hours" />
          <Row icon={Building2} label="Département" value={brand?.name} testId="ed-brand" />
          <Row
            icon={MapPin}
            label="Site"
            value={
              site ? (
                <>
                  <span className="font-medium">{site.name}</span>
                  {site.address && (
                    <span className="block text-xs text-zinc-600 font-mono mt-0.5">{site.address}</span>
                  )}
                </>
              ) : null
            }
            testId="ed-site"
          />
          <Row icon={Users} label="Bénéficiaire" value={beneficiary?.denomination} testId="ed-beneficiary" />
          <Row
            icon={Tag}
            label="Catégorie"
            value={
              category ? (
                <span className="inline-flex items-center gap-2">
                  <span className="h-2 w-2 rounded-full" style={{ backgroundColor: category.color || "#7C3AED" }} />
                  {category.name}
                </span>
              ) : null
            }
            testId="ed-category"
          />
          {event.notes && (
            <Row icon={FileText} label="Consignes / Commentaires" value={<span className="whitespace-pre-wrap">{event.notes}</span>} testId="ed-notes" />
          )}
        </div>
        <DialogFooter className="px-6 py-4 border-t border-zinc-100 bg-white">
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="ed-close-btn">Fermer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
